import { useEffect, useState } from "react"
import * as React from "react"
import { PaginationType, ZonePolicyDueDateType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useReactToPrint, UseReactToPrintFn } from "react-to-print"

import { canViewThisPage } from "@/lib/api/auth"
import { getZonePolicyTableData } from "@/lib/api/billing"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { zonePolicyDueColumns } from "@/components/table/columns/zone-policy-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import AddZonePolicyPage from "../zone-policy-due-date/add"

export const Route = createFileRoute(
  "/_home/zone-settings/zone-policy-due-date/",
)({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_clientzonepolicyduedate")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: ZonePolicyPage,
})

function ZonePolicyPage() {
  const [search, setSearch] = useState<string>("")
  const [zones, setZones] = useState<number[]>([])
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = useState<string | null>(null)

  const {
    data: policyDetails,
    isError,
    isLoading,
  } = useQuery<PaginationType<ZonePolicyDueDateType>>({
    queryKey: ["policyDetails", defaultPage, page, search, zones],
    queryFn: () => getZonePolicyTableData(defaultPage, page, search, zones),
  })

  useEffect(() => {
    if (policyDetails) {
      setNextPageUrl(policyDetails.next)
      setPrevPageUrl(policyDetails.previous)
    }
  }, [policyDetails])

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <div className="space-y-4 p-4">
      <Header>Policy Due Date</Header>
      <div ref={contentRef} className="print:p-2">
        <DataTable
          columns={zonePolicyDueColumns}
          data={policyDetails?.results ?? []}
          search={{
            //field: "id",
            label: "zone",
            value: search,
            onChange: setSearch,
          }}
          //tableTitle="Zone Policy Due Date"
          isLoading={isLoading}
          isError={isError}
          defaultPage={defaultPage}
          setDefaultPage={setDefaultPage}
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          page={page}
          setPage={setPage}
          totalCount={policyDetails?.count}
          zones={zones}
          setZones={setZones}
        >
          <div className="flex w-full justify-end">
            <AddZonePolicyPage />
            <Button className="mx-1" onClick={(e) => reactToPrintFn()}>
              <Icons.download />
              Print Zone Policy Due Date
            </Button>
            <ExportOperationModal
              tableData={policyDetails?.results ?? [{}]}
              fileName="Zone Policy Due Date"
              showExportModal={showExportModal}
              setShowExportModal={setShowExportModal}
            />
          </div>
        </DataTable>
      </div>
    </div>
  )
}
